import { render, staticRenderFns } from "./muhasebekoducomp.vue?vue&type=template&id=752b1227&"
import script from "./muhasebekoducomp.vue?vue&type=script&lang=js&"
export * from "./muhasebekoducomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports